import React from 'react';
import { Hammer, HardHat, BrickWall } from 'lucide-react';
import img1 from "../../assets/builders1.jpg";
import img2 from "../../assets/builders2.jpg";
import img3 from "../../assets/builders3.jpg";
import img4 from "../../assets/builders4.jpg";
import img5 from "../../assets/builders5.jpg";

const projects = [
  { 
    id: 1, 
    title: 'Modern Villa Construction', 
    category: 'Residential', 
    image: img1
  },
  { 
    id: 2, 
    title: 'Commercial High-Rise', 
    category: 'Commercial', 
    image: img2
  },
  { 
    id: 3, 
    title: 'Estate Restoration', 
    category: 'Renovation', 
    image: img3 
  },
  { 
    id: 4, 
    title: 'Structural Engineering', 
    category: 'Technical', 
    image: img4
  },
];

const LuxuryBuilders = () => {
  return (
    <div className="font-sans text-gray-800 bg-white">
      {/* Hero */}
      <div
        className="relative h-[60vh] w-full bg-cover bg-center"
        style={{ backgroundImage: `url(${img5})` }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
          <h4 className="text-amber-500 font-bold tracking-widest uppercase mb-3">Master Craftsmanship</h4>
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-4">Luxury Builders</h1>
          <p className="text-gray-200 text-lg max-w-xl">Building legacies with concrete, steel, and passion.</p>
        </div>
      </div>

      {/* Intro */}
      <section className="py-16 px-6 bg-white text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4">Foundations of Excellence</h2>
        <div className="w-20 h-1 bg-amber-500 mx-auto mb-6"></div>
        <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
          We don't just build houses; we construct landmarks. As premium builders, we manage the entire construction lifecycle—from the first brick to the final coat of paint—ensuring structural integrity and flawless finishing.
        </p>
      </section>

      {/* Gallery */}
      <section className="py-16 bg-gray-50 px-6">
        <div className="max-w-7xl mx-auto">
          <h3 className="text-3xl font-serif font-bold text-gray-900 mb-8 text-center md:text-left">Recent Projects</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {projects.map((item) => (
              <div key={item.id} className="group relative overflow-hidden shadow-lg cursor-pointer rounded-sm">
                <div className="h-80 overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transform group-hover:scale-110 transition duration-700"/>
                </div>
                <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/90 to-transparent p-6 pt-20">
                  <p className="text-amber-400 text-xs tracking-widest uppercase mb-1">{item.category}</p>
                  <h4 className="text-2xl font-serif text-white">{item.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 px-6 bg-stone-900 text-white">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="flex flex-col items-center">
            <HardHat className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Expert Team</h4>
            <p className="text-gray-400 text-sm">Civil engineers and architects with decades of experience.</p>
          </div>
          <div className="flex flex-col items-center">
            <BrickWall className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Premium Materials</h4>
            <p className="text-gray-400 text-sm">Sourcing only high-grade cement, steel, and stone.</p>
          </div>
          <div className="flex flex-col items-center">
            <Hammer className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Timely Delivery</h4>
            <p className="text-gray-400 text-sm">Strict adherence to project timelines and milestones.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 text-center bg-white">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6">Start Building Your Dream</h2>
        <button className="bg-amber-500 hover:bg-amber-600 text-white text-lg font-semibold px-8 py-3 rounded-sm transition shadow-lg">Request Construction Quote</button>
      </section>
    </div>
  );
};

export default LuxuryBuilders;